import { ComunicacaoBox } from './styles'
import { Tooltip } from "@material-ui/core";
import { isNullReturnHyphen, DateFormat } from "../../../functions"
import { useState } from 'react'
import { useSnackbar } from "notistack"
import { CircularProgress } from '@material-ui/core'
import SolicitacaoService from "../../../services/SolicitacaoService"
import { KeyboardBackspaceOutlined, GetAppOutlined, Check, Block } from '@material-ui/icons'
import DefereSolicitacao from '../../../pages/Triagem/DefereSolicitacao'
import IndefereSolicitacao from '../../../pages/Triagem/IndefereSolicitacao'
import webconfig from '../../../webconfig.json'

export default function SolicitacaoBox({
    solicitacao,
    setRecarregarTriagens,
    etapaSolicitacaoAcesso }) {

    const [arquivoDeferimento, setArquivoDeferimento] = useState({
        open: false,
        solicitacao: {}
    })

    const [arquivoIndeferimento, setArquivoIndeferimento] = useState({
        open: false,
        solicitacao: {}
    })

    const [loading, setLoading] = useState(false)
    const [loadingProcesso, setLoadingProcesso] = useState(false)

    const { enqueueSnackbar } = useSnackbar()

    const AbreDefereSolicitacao = () => {
        setLoading(true)
        SolicitacaoService.DownloadArquivoBase64(solicitacao.id)
            .then(response => {
                if (response.status === 200) {
                    setLoading(false)
                    setArquivoDeferimento({
                        open: true,
                        solicitacao: solicitacao,
                        conteudoReciboBase64: response.data.conteudo
                    })
                }
                else {
                    enqueueSnackbar('Não foi possível fazer donwload do Ofício. Contate o suporte.', { variant: 'error', autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
            .catch(error => {
                setLoading(false)
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    const AbreIndefereSolicitacao = () => {
        setLoading(true)
        SolicitacaoService.DownloadArquivoBase64(solicitacao.id)
            .then(response => {
                if (response.status === 200) {
                    setLoading(false)
                    setArquivoIndeferimento({
                        open: true,
                        solicitacao: solicitacao,
                        conteudoReciboBase64: response.data.conteudo
                    })
                }
                else {
                    enqueueSnackbar('Não foi possível fazer donwload do Ofício. Contate o suporte.', { variant: 'error', autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
            .catch(error => {
                setLoading(false)
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    const DownloadArquivoSolicitacao = () => {
        setLoading(true)
        SolicitacaoService.DownloadArquivoBase64(solicitacao.id)
            .then(response => {
                if (response.status === 200) {
                    let extensionFile = response.data.tipoArquivo
                    let a = document.createElement("a")
                    a.href = `data:${extensionFile};base64,${response.data.conteudo}`
                    a.download = response.data.nomeArquivo
                    a.click()

                    enqueueSnackbar('Download realizado com sucesso', { variant: 'success', autoHideDuration: webconfig.snackbarAutoHideDuration })
                    setLoading(false)
                }
                else {
                    enqueueSnackbar('Não foi possível fazer donwload do Ofício. Contate o suporte.', { variant: 'error', autoHideDuration: webconfig.snackbarAutoHideDuration })
                }

            })
            .catch(error => {
                setLoading(false)
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    const UndoDeferimento = () => {
        setLoading(true)
        SolicitacaoService.UndoDeferimento(solicitacao.id)
            .then(response => {
                if (response.status === 200) {
                    enqueueSnackbar(response.data, { variant: 'success', autoHideDuration: webconfig.snackbarAutoHideDuration })
                    setLoading(false)
                    let dataAtual = new Date();
                    setRecarregarTriagens(dataAtual.toString())
                }
                else {
                    enqueueSnackbar('Não foi possível fazer donwload do Ofício. Contate o suporte.', { variant: 'error', autoHideDuration: webconfig.snackbarAutoHideDuration })
                }

            })
            .catch(error => {
                setLoading(false)
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    const UndoIndeferimento = () => {
        setLoading(true)
        SolicitacaoService.UndoIndeferimento(solicitacao.id)
            .then(response => {
                if (response.status === 200) {
                    enqueueSnackbar(response.data, { variant: 'success', autoHideDuration: webconfig.snackbarAutoHideDuration })
                    setLoading(false)
                    let dataAtual = new Date();
                    setRecarregarTriagens(dataAtual.toString())
                }
                else {
                    enqueueSnackbar('Não foi possível fazer donwload do Ofício. Contate o suporte.', { variant: 'error', autoHideDuration: webconfig.snackbarAutoHideDuration })
                }

            })
            .catch(error => {
                setLoading(false)
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    const ObtenhaNomeOrgaoJurisdicionadoSolicitacao = (solicitacao) => {

        let retorno = ''

        if (solicitacao != null &&
            solicitacao.usuario != null &&
            solicitacao.usuario.listaOrgaosJurisdicionados != null) {

            solicitacao.usuario.listaOrgaosJurisdicionados.forEach((item) => {
                if (item.solicitacaoId === solicitacao.id) {
                    retorno = item.nomeOrgaoJurisdicionado
                }
            })
        }
        return retorno
    }

    return (
        <>
            <DefereSolicitacao
                arquivo={arquivoDeferimento}
                setArquivo={setArquivoDeferimento}
                setRecarregarTriagens={setRecarregarTriagens}
            />

            <IndefereSolicitacao
                arquivo={arquivoIndeferimento}
                setArquivo={setArquivoIndeferimento}
                setRecarregarTriagens={setRecarregarTriagens}
            />

            <ComunicacaoBox.Desktop id="ComunicacaoBox" >
                <ComunicacaoBox.Content id="ComunicacaoBoxContent">
                    <ComunicacaoBox.Acao id="ComunicacaoBoxAcao">
                        {
                            (solicitacao.situacao === 0 &&
                                <>
                                    <Tooltip title="Deferir Acesso" placement="top">
                                        <ComunicacaoBox.BotaoAcao
                                            className="bg-hover--ui-color-10 border--ui-color-10 color--ui-color-10 color-hover--ui-white"
                                            disabled={loadingProcesso}
                                            onClick={AbreDefereSolicitacao}
                                            title='Indeferir Acesso'
                                        >
                                            {
                                                loading
                                                    ?
                                                    <CircularProgress
                                                        size={22}
                                                        style={{
                                                            color: '#ffffff'
                                                        }} />
                                                    : <Check />
                                            }
                                        </ComunicacaoBox.BotaoAcao>
                                    </Tooltip>

                                    <Tooltip title="Indeferir Acesso" placement="top">
                                        <ComunicacaoBox.BotaoAcao
                                            className="bg-hover--ui-color-03 border--ui-color-03 color--ui-color-03 color-hover--ui-white"
                                            disabled={loadingProcesso}
                                            onClick={AbreIndefereSolicitacao}
                                        >
                                            {
                                                loading
                                                    ?
                                                    <CircularProgress
                                                        size={22}
                                                        style={{
                                                            color: '#ffffff'
                                                        }} />
                                                    : <Block />
                                            }
                                        </ComunicacaoBox.BotaoAcao>
                                    </Tooltip>

                                    <Tooltip title="Download Arquivo" placement="top">
                                        <ComunicacaoBox.BotaoAcao
                                            className="bg-hover--ui-color-07 border--ui-color-07 color--ui-color-07 color-hover--ui-white"
                                            disabled={loadingProcesso}
                                            title='Arquivo Solicitação'
                                            onClick={DownloadArquivoSolicitacao}
                                        >
                                            {
                                                loading
                                                    ?
                                                    <CircularProgress
                                                        size={22}
                                                        style={{
                                                            color: '#ffffff'
                                                        }} />
                                                    : <GetAppOutlined />
                                            }
                                        </ComunicacaoBox.BotaoAcao>
                                    </Tooltip>
                                </>
                            )
                            ||
                            (solicitacao.situacao === 3 &&
                                <>
                                    <Tooltip title="Retornar Solicitação para Pendente de Triagem" placement="top">
                                        <ComunicacaoBox.BotaoAcao
                                            className="bg-hover--ui-color-12 border--ui-color-12 color--ui-color-12 color-hover--ui-white"
                                            disabled={loadingProcesso}
                                            onClick={UndoDeferimento}
                                        >
                                            {
                                                loading
                                                    ?
                                                    <CircularProgress
                                                        size={22}
                                                        style={{
                                                            color: '#ffffff'
                                                        }} />
                                                    : <KeyboardBackspaceOutlined />
                                            }
                                        </ComunicacaoBox.BotaoAcao>
                                    </Tooltip>

                                    <Tooltip title="Revogar Acesso" placement="top">
                                        <ComunicacaoBox.BotaoAcao
                                            className="bg-hover--ui-color-03 border--ui-color-03 color--ui-color-03 color-hover--ui-white"
                                            disabled={loadingProcesso}
                                            onClick={AbreIndefereSolicitacao}
                                        >
                                            {
                                                loading
                                                    ?
                                                    <CircularProgress
                                                        size={22}
                                                        style={{
                                                            color: '#ffffff'
                                                        }} />
                                                    : <Block />
                                            }
                                        </ComunicacaoBox.BotaoAcao>
                                    </Tooltip>

                                    <Tooltip title="Download Arquivo" placement="top">
                                        <ComunicacaoBox.BotaoAcao
                                            className="bg-hover--ui-color-07 border--ui-color-07 color--ui-color-07 color-hover--ui-white"
                                            disabled={loadingProcesso}
                                            title='Arquivo Solicitação'
                                            onClick={DownloadArquivoSolicitacao}
                                        >
                                            {
                                                loading
                                                    ?
                                                    <CircularProgress
                                                        size={22}
                                                        style={{
                                                            color: '#ffffff'
                                                        }} />
                                                    : <GetAppOutlined />
                                            }
                                        </ComunicacaoBox.BotaoAcao>
                                    </Tooltip>
                                </>
                            )
                            ||
                            ((solicitacao.situacao === 2 || solicitacao.situacao === 4) &&
                                <>
                                    <Tooltip title="Volta a solicitação para situação que estava anteriormente" placement="top">
                                        <ComunicacaoBox.BotaoAcao
                                            className="bg-hover--ui-color-12 border--ui-color-12 color--ui-color-12 color-hover--ui-white"
                                            disabled={loadingProcesso}
                                            onClick={UndoIndeferimento}
                                        >
                                            {
                                                loading
                                                    ?
                                                    <CircularProgress
                                                        size={22}
                                                        style={{
                                                            color: '#ffffff'
                                                        }} />
                                                    : <KeyboardBackspaceOutlined />
                                            }
                                        </ComunicacaoBox.BotaoAcao>
                                    </Tooltip>

                                    <Tooltip title="Download Arquivo" placement="top">
                                        <ComunicacaoBox.BotaoAcao
                                            className="bg-hover--ui-color-07 border--ui-color-07 color--ui-color-07 color-hover--ui-white"
                                            disabled={loadingProcesso}
                                            title='Download Arquivo'
                                            onClick={DownloadArquivoSolicitacao}>
                                            {
                                                loading
                                                    ?
                                                    <CircularProgress
                                                        size={22}
                                                        style={{
                                                            color: '#ffffff'
                                                        }} />
                                                    : <GetAppOutlined />
                                            }
                                        </ComunicacaoBox.BotaoAcao>
                                    </Tooltip>
                                </>
                            )
                        }
                    </ComunicacaoBox.Acao>
                    <ComunicacaoBox.Documento id="ComunicacaoBoxDocumento">
                        <ComunicacaoBox.Informacao>
                            <span title="Data Solicitação">Data Solicitação</span>
                            <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(DateFormat(solicitacao.dataSolicitacao))}>{isNullReturnHyphen(DateFormat(solicitacao.dataSolicitacao))}</ComunicacaoBox.DadoComunicacao>
                        </ComunicacaoBox.Informacao>

                        <ComunicacaoBox.Informacao>
                            <span title="Nome Gestor">Nome</span>
                            <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(solicitacao.usuario != null ? solicitacao.usuario.nome : '')}>{isNullReturnHyphen(solicitacao.usuario != null ? solicitacao.usuario.nome : '')}</ComunicacaoBox.DadoComunicacao>
                        </ComunicacaoBox.Informacao>

                        <ComunicacaoBox.Informacao>
                            <span title="CPF do Gestor">CPF</span>
                            <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(solicitacao.usuario != null ? solicitacao.usuario.cpf : '')}>{isNullReturnHyphen(solicitacao.usuario != null ? solicitacao.usuario.cpf : '')}</ComunicacaoBox.DadoComunicacao>
                        </ComunicacaoBox.Informacao>

                        <ComunicacaoBox.Informacao>
                            <span title="e-mail Gestor">e-mail</span>
                            <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(solicitacao.usuario != null ? solicitacao.usuario.email : '')}>{isNullReturnHyphen(solicitacao.usuario != null ? solicitacao.usuario.email : '')}</ComunicacaoBox.DadoComunicacao>
                        </ComunicacaoBox.Informacao>

                        <ComunicacaoBox.Informacao>
                            <span title="Telefone">Telefone</span>
                            <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(solicitacao.usuario != null ? solicitacao.usuario.telefone : '')}>{isNullReturnHyphen(solicitacao.usuario != null ? solicitacao.usuario.telefone : '')}</ComunicacaoBox.DadoComunicacao>
                        </ComunicacaoBox.Informacao>

                        <ComunicacaoBox.Informacao>
                            <span title="Situação da Solicitação">Situação</span>
                            <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(solicitacao.situacaoTexto)}>{isNullReturnHyphen(solicitacao.situacaoTexto)}</ComunicacaoBox.DadoComunicacao>
                        </ComunicacaoBox.Informacao>

                        <ComunicacaoBox.Informacao>
                            <span title="Órgão Jurisdicionado">Órgão Jurisdicionado</span>
                            <ComunicacaoBox.DadoComunicacao
                                className="txt-oficio"
                                title={isNullReturnHyphen(ObtenhaNomeOrgaoJurisdicionadoSolicitacao(solicitacao))}>
                                {isNullReturnHyphen(ObtenhaNomeOrgaoJurisdicionadoSolicitacao(solicitacao))}</ComunicacaoBox.DadoComunicacao>
                        </ComunicacaoBox.Informacao>

                        {solicitacao.nomePessoaDoUsuarioTriagem && (
                            <ComunicacaoBox.Informacao>
                                <span title="Usuário Triagem">Usuário Triagem</span>
                                <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(solicitacao.nomePessoaDoUsuarioTriagem)}>{isNullReturnHyphen(solicitacao.nomePessoaDoUsuarioTriagem)}</ComunicacaoBox.DadoComunicacao>
                            </ComunicacaoBox.Informacao>
                        )}

                        {solicitacao.dataTriagem && (
                            <ComunicacaoBox.Informacao>
                                <span title={etapaSolicitacaoAcesso.find((item) => item === 0) !== undefined ? "Data Triagem" : "Data Deferimento"}>Data {etapaSolicitacaoAcesso.find((item) => item === 0) !== undefined ? 'Triagem' : 'Deferimento'}</span>
                                <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(DateFormat(solicitacao.dataTriagem))}>{isNullReturnHyphen(DateFormat(solicitacao.dataTriagem))}</ComunicacaoBox.DadoComunicacao>
                            </ComunicacaoBox.Informacao>
                        )}

                        {solicitacao.dataRevogacao && (
                            <ComunicacaoBox.Informacao>
                                <span title="Data Revogação">Data Revogação</span>
                                <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(DateFormat(solicitacao.dataRevogacao))}>{isNullReturnHyphen(DateFormat(solicitacao.dataRevogacao))}</ComunicacaoBox.DadoComunicacao>
                            </ComunicacaoBox.Informacao>
                        )}

                        {solicitacao.motivoNegativa && (
                            <ComunicacaoBox.Informacao>
                                <span title="Motivo Negativa/Revogação">Motivo Negativa/Revogação</span>
                                <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(solicitacao.motivoNegativa)}>{isNullReturnHyphen(solicitacao.motivoNegativa)}</ComunicacaoBox.DadoComunicacao>
                            </ComunicacaoBox.Informacao>
                        )}
                    </ComunicacaoBox.Documento>
                </ComunicacaoBox.Content>
            </ComunicacaoBox.Desktop>
        </>
    )
}